import {
    Text,
    Image,
    View
} from '@react-pdf/renderer';
import logo from '../../logo.png';
import defaultStyles from '../print-pdf/defaultStyles';
import { PrintDate } from '+/components/PrintDate';
import {
    Table,
    TableHeader,
    DataTableCell,
    TableCell,
    TableBody
} from '@david.kucsai/react-pdf-table';
import { chunk } from 'lodash';

const DelinquencyLegend = props => {

    const { totalDelinquentForProperty, totalDelinquentForExictions } = props;

    return (
        <View style={{
            ...defaultStyles.tableCover,
            marginLeft: '10px',
            marginTop: 15,
            width: '300px'

        }}>
            <Table
                data={[
                    {
                        Total_Owed: 'Entire Property',
                        Amount: totalDelinquentForProperty
                    },
                    {
                        Total_Owed: 'Eviction Only',
                        Amount: totalDelinquentForExictions
                    }
                ]}
            >
                <TableHeader>
                    <TableCell style={defaultStyles.tableCell} > Total Owed </TableCell>
                    <TableCell style={{
                        ...defaultStyles.tableCell,
                        textAlign: 'center'
                    }}> Amount </TableCell>
                </TableHeader>
                <TableBody>
                    <DataTableCell style={defaultStyles.tableCell} getContent={r => r.Total_Owed}/>
                    <DataTableCell style={{
                        ...defaultStyles.tableCell,
                        textAlign: 'center'
                    }} getContent={r => r.Amount}/>
                </TableBody>
            </Table>
        </View>
    );
};

const ColorLegend = props => {

    const { counts, dataBuildingOccupancy } = props;

    const data = [
        {
            Color: '#ffd599',
            Color_Legend: 'Total Delinquent > $1000',
            Count: counts.total_delinquent
        },
        {
            Color: '#ffd599',
            Color_Legend: 'Fulls',
            Count: counts.fulls
        },
        {
            Color: '#d983e4',
            Color_Legend: 'Section 8',
            Count: counts.section_8
        },
        {
            Color: '#b7dfb9',
            Color_Legend: 'NSF',
            Count: counts.nsf
        },
        {
            Color: '#B7D5F4',
            Color_Legend: 'Adjustment',
            Count: counts.adjustment
        },
        {
            Color: '#fab3ae',
            Color_Legend: 'Eviction',
            Count: counts.eviction
        },
        {
            Color: '#9e9e9ebf',
            Color_Legend: 'Stipulation',
            Count: counts.stipulation
        },
        {
            Color: '#b7dfb9',
            Color_Legend: 'Repayment Agreement',
            Count: counts.repayment_agreement
        },
        {
            Color: '#a5eff1bf',
            Color_Legend: 'Employee',
            Count: counts.employee
        },
        {
            Color: '#e4b152bf',
            Color_Legend: 'Govt. Assistance',
            Count: counts.govt_assistance
        },
        {
            Color: '#F6F0BC',
            Color_Legend: 'Exception',
            Count: counts.exception
        },
        {
            Color: '',
            Color_Legend: '',
            Count: ''
        },
        {
            Color: 'white',
            Color_Legend: 'Occupied Units',
            Count: dataBuildingOccupancy.occupied_units
        },
        {
            Color: 'white',
            Color_Legend: 'Vacant Units',
            Count: dataBuildingOccupancy.vacant_units
        }
    ];

    const chunks = chunk(data, 4);

    return chunks.map((data, i) => (
        <View key={i} style={{
            ...defaultStyles.tableCover,
            marginLeft: '10px',
            marginTop: 15,
            width: '300px'
        }}>
            <View>
                <Table
                    data={data}
                >
                    <TableHeader>
                        <TableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '10px',
                            borderWidth: 0
                        }}> </TableCell>
                        <TableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '90px'
                        }}> Color Legend </TableCell>
                        <TableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '25px',
                            textAlign: 'center'
                        }} > Count </TableCell>
                    </TableHeader>
                    <TableBody>
                        <DataTableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '10px',
                            borderWidth: 0
                        }} getContent={r => (
                            <>
                                <Text style={{
                                    ...defaultStyles.white,
                                    backgroundColor: r.Color
                                }}></Text>

                            </>
                        )} />
                        <DataTableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '90px'
                        }} getContent={r => (
                            <>

                                <Text>{ r.Color_Legend }</Text>
                            </>
                        )} />
                        <DataTableCell style={{
                            ...defaultStyles.tableCell,
                            maxWidth: '25px',
                            textAlign: 'center'
                        }} getContent={r => r.Count}/>

                    </TableBody>
                </Table>
            </View>
        </View>
    ));


};

const Logo = props => {


    const {
        property_name
    } = props;

    return (

        <View style={{
            width: '120px',
            marginLeft: '10px',
            marginTop: 5
        }}>
            <Image style={defaultStyles.logo_header} alt='logo' src={logo} />
            <Text style={defaultStyles.title_header}>
                    Delinquency Report for:
            </Text>
            <br/>
            <Text style={defaultStyles.title_header}>
                {property_name}
            </Text>
            <div>
                <PrintDate isForPDF={true} />
            </div>
        </View>


    );
};
const CoverPage = props => {

    const {
        property_name,
        counts,
        dataBuildingOccupancy,
        totalDelinquentForProperty,
        totalDelinquentForExictions

    } = props;


    return (

        <View style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%'
        }}>

            <Logo property_name={property_name}></Logo>
            <DelinquencyLegend
                totalDelinquentForProperty={totalDelinquentForProperty}
                totalDelinquentForExictions={totalDelinquentForExictions}/>
            <ColorLegend counts={counts} dataBuildingOccupancy={dataBuildingOccupancy} />
        </View>


    );
};

export default CoverPage;
